const baseURL = "https://meraki.canatwin.com/api/";
const googleLoginURL = `https://meraki.canatwin.com/api/googlelogin/`;

export { baseURL, googleLoginURL };
    